import React, { useMemo } from "react";
import { AgCharts } from "ag-charts-react";
import { Box } from "@amzn/awsui-components-react";

const RATING_COLORS = {
  Green: '#1d8102',
  Yellow: '#d4a017',
  Red: '#d13212',
  Error: '#5f6b7a',
  'Not Analyzed': '#aab7b8',
};

const ArqaRatingsPieChart = ({ ratings, title }) => {
  if (!ratings) return null;

  const total = Object.values(ratings).reduce((sum, v) => sum + v, 0);
  if (total === 0) return null;

  const data = Object.entries(ratings)
    .filter(([, value]) => value > 0)
    .map(([key, value]) => ({ rating: key, count: value }));

  // Use explicit color mapping for ratings chart, default palette for teams
  const hasRatingColors = data.every(d => RATING_COLORS[d.rating]);
  const fills = hasRatingColors
    ? data.map(d => RATING_COLORS[d.rating])
    : undefined;

  const options = useMemo(() => ({
    data,
    series: [
      {
        type: 'pie',
        angleKey: 'count',
        calloutLabelKey: 'rating',
        sectorLabelKey: 'count',
        sectorLabel: {
          formatter: ({ datum }) => `${datum.count}`,
          color: '#fff',
          fontSize: 11,
        },
        ...(fills ? { fills, strokes: fills } : {}),
      },
    ],
    legend: { enabled: false },
    padding: { top: 5, bottom: 5, left: 5, right: 5 },
  }), [data, fills]);

  return (
    <div>
      {title && <Box variant="h4" margin={{ bottom: 'xxs' }}>{title}</Box>}
      <div style={{ height: '280px', width: '100%' }}>
        <AgCharts options={options} />
      </div>
    </div>
  );
};

export default ArqaRatingsPieChart;
